const api = {
  GET_LIST_BANK_AS_CLIENT_LOG: '/index.php?r=api/v1/system_log/service-log/bank-as-client',
};

export default api;
